<template>
  <div class="card">
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert color="success" v-if="show_success" class="mx-2 mt-2"
        >{{ alert_msg }}
      </argon-alert>
      <div class="table-responsive p-0" v-if="electricalList">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Descrizione
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Stato
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Data creazione
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="electrical in electricalList" :key="electrical._id">
              <table-row :item="electrical" />
              <td class="align-middle">
                <a
                  @click="editElectrical(electrical._id)"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Modifica"
                  href="javascript:;"
                >
                  <i class="fa fa-pen"></i
                ></a>
                <a
                  @click.stop="openModal(electrical._id)"
                  class="text-secondary font-weight-bold text-xs ms-2"
                  data-toggle="tooltip"
                  data-original-title="Elimina"
                  href="javascript:;"
                >
                  <i class="fa fa-trash"></i
                ></a>
                <delete-modal
                  :modalId="'deleteModal' + electrical._id"
                  :object="electrical"
                  @deleteObject="deleteElectrical"
                  @closeModal="closeModal(electrical._id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TableRow from "@/components/TableRow.vue";
import router from "@/router";
import DeleteModal from "@/components/deleteModal.vue";
import axios from "axios";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "electrical-table",
  props: {
    electricals: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // pages: {type: Number},
    // total: {type: Number},
    // pagination_size: {type: Number},
  },
  data() {
    return {
      show_success: false,
      alert_msg: "",
      electricalList: {}
    };
  },
  components: { ArgonAlert, DeleteModal, TableRow },
  mounted() {
    this.electricalList = this.electricals;
  },
  methods: {
    editElectrical(electricalId) {
      router.push({ name: "Modifica test elettrici", params: { id: electricalId } });
    },
    openModal(id) {
      this.$vfm.open("deleteModal" + id);
    },
    async closeModal(id) {
      await router.push({ name: "Lista test elettrici" });
      await this.$vfm.close("deleteModal" + id);
    },
    async deleteElectrical(electrical) {
      this.$emit("deleteObject", electrical);
      const response = await axios.delete(
        this.$endpoint + "/electrical/delete/" + electrical._id,
        {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        }
      );

      if (response.data.status === "OK") {
        this.show_success = true;
        this.alert_msg = "Test elettrico eliminato con successo";
        const index = this.electricalList.findIndex(obj => obj._id === electrical._id) // find the post index
        if (~index) // if the post exists in array
          this.electricalList.splice(index, 1) //delete the post
      }

      await this.closeModal(electrical._id);
    },
  },
};
</script>
